<div class="category-template">
    <!-- Title and the "also used by" pill read as one block, so they sit closer to each
         other than to the preview below - the card's own 12px gap separates the two. -->
    <div class="d-flex flex-column gap-4">
        <h6 class="category-template__title">
            {{ baseCategoryNameModel }} {{ 'manageCat_template' | translate: param }}
        </h6>

    @if (orgCategoryListByBaseCatId.length > 0) {
        <div class="category-template__usage">
            <p>{{ ('manageCat_templateUsing_msg1' | translate: param).trim() }}:</p>
            <span class="category-template__usage-link" (click)="fnOpenActiveCategories()">{{ orgCategoryListByBaseCatId.length }}{{ 'manageCat_templateUsing_msg2' | translate: param }}
                <img [src]="ICONS.CHEVRON_RIGHT" class="icons" alt="" />
            </span>
        </div>
    }
</div>
    <div class="category-template__preview">
        <img [src]="previewImage" alt="{{ baseCategoryNameModel }}" />
    </div>
</div>
